class ColorSwatch extends HTMLElement {
  constructor() {
    super();
    
    this.card = this.closest('.product-card-wrapper');
    this.allSiblings = this.card.querySelectorAll('color-swatch');
    // this.buttonATC = this.card.querySelector('.quick-add__submit');
                              
    this.variantId = this.getAttribute('data-id');
    this.variantPrice = this.getAttribute('data-price');
    this.variantImage = this.getAttribute('data-image');
    // this.variantAvailability = this.getAttribute('data-avail');    
    
    this.targetInput = this.card.querySelector('[name="id"]');
    this.targetPrice = this.card.querySelector('.price-value');
    this.targetImage = this.card.querySelector('.card-featured-media');
    
    this.addEventListener('pointerenter', this.init.bind(this));
  }

  init() {
    this.allSiblings.forEach(sibling => sibling.classList.remove('active'));
    this.classList.add('active');
    this.targetPrice.innerHTML = this.variantPrice;
    this.targetImage.setAttribute('src', this.variantImage);
    this.targetImage.removeAttribute('srcset');
    if(this.targetInput) this.targetInput.value = this.variantId;
    
    // if(this.variantAvailability == 'true') {
    //   this.buttonATC.classList.remove('quick_add_disabled');
    //   this.buttonATC.removeAttribute('disabled');
    // } else {
    //   this.buttonATC.classList.add('quick_add_disabled');
    //   this.buttonATC.setAttribute('disabled', true);
    // }
  }
}

customElements.define('color-swatch', ColorSwatch);